module.exports = __webpack_public_path__ + "img/logo-greatpriory.0def1964.png";